import Layout from "@/components/layout/Layout.vue"
import CreateForm from "@/views/sys/role/create/Create.vue"
import { deleteRoles, getRoles } from "@/api/role"

const columns = [
    { title: '名称', dataIndex: 'name' },
    { title: '状态', dataIndex: 'enabled' , scopedSlots: { customRender: 'status' } },
    { title: '是否展示禁用优化师', dataIndex: 'show_display_worker' , scopedSlots: { customRender: 'show_display_worker' } },
    { title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' } }
]

export default {
    name: 'roles',
    components: {
        Layout,
        CreateForm
    },
    data () {
        return {
            data: [],
            pagination: { defaultPageSize: 20 },
            loading: false,
            selectedRowKeys: [],
            columns,
            model: {},
            showForm: false
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        create(record) {
            this.model = record.id ? Object.assign({}, record) : { enabled: true }
            this.$refs.createForm.defaultCheck(this.model)
            this.showForm = true
        },
        destroy(record) {
            const del = ids => {
                deleteRoles(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            }
            getRoles(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            });
        },
        refresh() {
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('RoleController', route)
        },
    }
}
